import { Button, Form, Input } from "antd";
import { LoginModel } from "../../../../models/account/chamadas/loginModel";
import { useAppDispatch } from "../../../../util/hooks";
import { useNavigate } from "react-router-dom";
import { login } from "../../../../services/accountService";

type FormProps = {
  password: string;
  email: string;
};

const Login = () => {
  //hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  //estados locais
  const [form] = Form.useForm<FormProps>();

  const submit = (values: FormProps) => {
    let args: LoginModel = {
      email: values.email,
      password: values.password,
      clientId: "FinPasApp",
      grantType: "password",
      refreshToken: "",
    };
    dispatch(login({ value: args, navigate: navigate }));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Form.Item
        label="Endereço de e-mail"
        name="email"
        rules={[
          {
            required: true,
            message: "Digite seu email",
          },
        ]}
      >
        <Input type="text" placeholder="Digite seu e-mail" />
      </Form.Item>
      <Form.Item
        label="Digite sua senha"
        name="password"
        rules={[
          {
            required: true,
            message: "Digite sua senha",
          },
        ]}
      >
        <Input type="password" placeholder="Digite sua senha" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" className="submitButton">
          Entrar
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Login;
